import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MessageBannerComponent } from './message-banner.component';

@NgModule({
  imports: [CommonModule, NzIconModule],
  declarations: [MessageBannerComponent],
  exports: [MessageBannerComponent],
})
export class MessageBannerModule {}
